import { TextField } from '@mui/material';
import { ChangeEvent, SetStateAction, Dispatch } from 'react';
import { ARIA_LABEL } from '@/constants/ariaLabel';
import { TextFieldCharactersCounter } from '@/components/common/TextFieldCharactersCounter';
import { TEXT_FIELD_CONSTANCE } from '../constants';

interface EvaluationCommentFieldProps {
  comment: string;
  addComment: Dispatch<SetStateAction<string>> | ((value: string) => void);
  placeholder?: string;
}

export const EvaluationCommentField = ({
  comment,
  addComment,
  placeholder = TEXT_FIELD_CONSTANCE.PLACEHOLDER_MISTAKE,
}: EvaluationCommentFieldProps) => {
  const handleCommentChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.value.length <= TEXT_FIELD_CONSTANCE.CHARACTERS_LIMIT) {
      addComment(event.target.value);
    }
  };

  return (
    <>
      <TextField
        multiline
        data-testid={ARIA_LABEL.EVALUATION_COMMENT_FIELD}
        value={comment}
        placeholder={placeholder}
        onChange={handleCommentChange}
        minRows={6}
        maxRows={16}
        inputProps={{
          maxLength: TEXT_FIELD_CONSTANCE.CHARACTERS_LIMIT,
        }}
      />
      <TextFieldCharactersCounter text={comment} />
    </>
  );
};
